// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Chart: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M25.5 6.3h-1.4C11.1 6.3.5 16.8.5 29.8c0 13.5 10.1 23.6 23.6 23.6 12.5 0 23.5-11 23.5-23.5v-1.4H25.5V6.3zm19.4 25c-.8 10.4-10.3 19.4-20.8 19.4-11.9 0-20.8-8.9-20.8-20.8C3.3 19 12 9.8 22.7 9.1v22.2h22.2z"/><path d="M29.9.6h-1.4v25h25v-1.5C53.4 11.1 42.8.6 29.9.6zm20.8 22.2H31.3V3.3c10.4.8 18.7 9.2 19.4 19.5z"/></svg>;
};

export default React.memo(Chart);
